<template>
    <div>
        <div class="search-box gauge_20">
            <div class="input-item">
                <span class="label"><span class="star">*</span>统计机构</span>
                <selectTree :clearable="false" v-model="search.organizationId" type="4" @change="initData" ref="selectTreeRef"></selectTree>
            </div>

            <div class="input-item-01">
                <span class="star">*</span>
                <span class="label">统计周期</span>
                <div class="cycle">
                    <div
                        class="tab"
                        :class="{ active: item.value == cycleActiveIndex }"
                        @click="clickCycle(item.value)"
                        v-for="item in cycleList"
                        :key="item.value"
                    >
                        <a>{{ item.label }}</a>
                    </div>
                </div>
                <DatePicker
                    :disabled="cycleActiveIndex != 4"
                    style="width: 240px"
                    :clearable="false"
                    type="daterange"
                    split-panels
                    separator="至"
                    placement="bottom"
                    v-model="search.validDate"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @on-ok="changeDatePicker('DatePicker1')"
                    @on-change="changeDatePicker('DatePicker1')"
                    :options="options"
                    :editable="false"
                    :confirm="true"
                    ref="DatePicker1"
                >
                </DatePicker>
                <span class="tips" v-if="result">* 统计周期区间最长为366天</span>
            </div>
        </div>

        <div class="search-box gauge_20" style="margin-top:5px;">
            <div class="input-item">
                <span class="label">长短险</span>
                <Select
                    v-model="search.productType"
                    clearable
                    @on-change="initData('productType', $event)"
                >
                    <Option value="1">长险</Option>
                    <Option value="2">短险</Option>
                </Select>
            </div>

            <div class="input-item">
                <span class="label">险种分类</span>
                <Select
                    v-model="search.themeIds"
                    multiple
                    :max-tag-count='3'
                    @on-open-change="initData('themeIds', $event)"     
                >
                    <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
                </Select>
            </div>

            <div class="input-item">
                <span class="label">产品名称</span>
                <Select
                    filterable
                    v-model="search.productCode"
                    clearable
                    @on-change="initData('productCode', $event)"
                >
                    <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productName }}</Option>
                </Select>
            </div>
        </div>

        <div class="btn-item config">
            <Button type="primary" @click="exportStatisticsList">导出</Button>
        </div>

        <div class="statistics-container">
            <div class="statistics-item">
                <span class="total-text">团队合计</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
                <span>件数</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fee || 0 }}</span>
                <span>规模保费(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fyb || 0 }}</span>
                <span>标准保费(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fybPerPolicyNum || 0 }}</span>
                <span>件均标保(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.policyNumPerCustomerNum || 0 }}</span>
                <span>客均件数</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fybPerCustomerNum || 0 }}</span>
                <span>客均标保(元)</span>
            </div>
        </div>

        <loading :isShow="$root.$children[0].isShowLoading" />
        <div class="table-box setTable">
            <Table 
                :columns="columns" 
                :data="tableData" 
                @on-sort-change="tableSortChange"
                :no-data-text="`<img class='no-img' src=${noImgUrl} /><div class='no-data-text'>无直属团队数据<div>`">
            >
                <template slot-scope="{ row }" slot="finishRate">
                    <div class="finish-rate">
                        <div class="speed" v-if="row.finishRate">
                            <div class="speed-box" :style="{ width: row.percent }"></div>
                        </div>
                        <span class="num" :class="{ 'text-center': !row.finishRate, 'up-to': row.finishRate > statisticsObj.finishRate }">{{
                            row.finishRate ? row.percent : '-'
                        }}</span>
                    </div>
                </template>
            </Table>
        </div>

        <div class="pageBox">
            <Page
                :total="total"
                :current="search.pageNo"
                :page-size="search.pageSize"
                show-total
                @on-change="pageChange"
                style="text-align: center"
            />
        </div>
    </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import filters from '@/api/filter';
import noImgUrl from '@/static/images/no-data.png';

export default {
    name: 'team',
    components: { selectTree },
    filters,
    data() {
        return {
            noImgUrl,
            total: 0,
            search: {
                queryType: '1', //1 机构业绩 2业务进度
                type: 2, //类型 (1 机构 2 团队 3 渠道 4 个人)
                pageNo: 1,
                pageSize: 10
            },
            cycleActiveIndex: 1,
            productList: [],
            themeList: [],
            cycleList: [
                {
                    label: '本月',
                    value: '1'
                },
                {
                    label: '本季',
                    value: '2'
                },
                {
                    label: '本年',
                    value: '3'
                },
                {
                    label: '自定义',
                    value: '4'
                }
            ],
            columns: [
                {
                    title: '序号',
                    align: 'center',
                    width: 80,
                    type: 'index'
                },
                {
                    title: '直属团队名称',
                    key: 'name',
                    minWidth: 200,
                    align: 'center',
                },
                {
                    title: '件数',
                    key: 'policyNum',
                    minWidth: 120,
                    sortable: 'custom',
                    align: 'center',
                    tooltip: true
                },
                {
                    title: '规模保费(元)',
                    key: 'fee',
                    minWidth: 120,
                    align: 'center',
                    sortable: 'custom',
                    tooltip: true
                },
                {
                    title: '标准保费(元)',
                    key: 'fyb',
                    minWidth: 120,
                    sortable: 'custom',
                    align: 'center',
                    tooltip: true,
                    sortType:'desc'
                },
                {
                    title: '件均标保(元)',
                    key: 'fybPerPolicyNum',
                    minWidth: 120,
                    align: 'center',
                    sortable: 'custom',
                    tooltip: true,
                    render(h, params) {
                        const fybPerPolicyNum = params.row.fybPerPolicyNum;
                        return <span>{fybPerPolicyNum ? fybPerPolicyNum : '0'}</span>;
                    }
                },
                {
                    title: '客均件数',
                    minWidth: 120,
                    align: 'center',
                    key: 'policyNumPerCustomerNum',
                    sortable: 'custom',
                    render(h, params) {
                        const policyNumPerCustomerNum = params.row.policyNumPerCustomerNum;
                        return <span>{policyNumPerCustomerNum ? policyNumPerCustomerNum : '0'}</span>;
                    }
                },
                {
                    title: '客均标保(元)',
                    minWidth: 120,
                    align: 'center',
                    key: 'fybPerCustomerNum',
                    sortable: 'custom',
                    render(h, params) {
                        const fybPerCustomerNum = params.row.fybPerCustomerNum;
                        return <span>{fybPerCustomerNum ? fybPerCustomerNum : '0'}</span>;
                    }
                }
            ],
            tableData: [],
            statisticsObj: {},
            options:{
                disabledDate:date =>{
                    return date.getTime() > new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1;
                }
            },
            result: false
        };
    },
    created() {
        this.setDatePeriod();
        this.search.organizationId = JSON.parse(localStorage.userInfo).organId;
        this.$nextTick(() => {
            this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
        this.queryProduct();
        this.queryTheme();
        // this.initData();
    },
    mounted() {
        this.$nextTick(()=>{
            document.querySelectorAll('.ivu-btn-default')[0].style = 'display:none;';
        })
    },
    methods: {
        setDatePeriod() {
            var monthStart = '';
            var monthEnd = filters.filterTime(new Date(), 'YYYY-MM-DD');
            if(this.cycleActiveIndex==1) {// 设置本月时间
                monthStart = filters.filterTime(new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0)), 'YYYY-MM-DD');
            }else if(this.cycleActiveIndex==2) {//本季
                monthStart = filters.getQuater('s', 0);
            }else if(this.cycleActiveIndex==3) {//本年
                monthStart = filters.filterTime(new Date(new Date().getFullYear(), 0, 1), 'YYYY-MM-DD');
            }
            this.search.validDate = [monthStart, monthEnd];
        },

        // 导出
        exportStatisticsList() {
            this.$root.$children[0].isShowLoading = true;
            let data = JSON.parse(JSON.stringify(this.setRequestParam()));
            delete data.pageNo;
            delete data.pageSize;
            this.$http({
                url: '/buz/dataCenter/exportStatisticsList',
                type: 'POST',
                forced: true,
                responseType: "blob",
                All: true,
                data,
            }).then(res => {
                this.$units.daochu(res);
            }).finally(() => {
                this.$root.$children[0].isShowLoading = false;
            });
        },

        // 险种分类
        queryTheme() {
            this.$http({
                url: '/buz/productTheme/array/first',
                type: 'GET'
            }).then(res => {
                this.themeList = res.data;
            });
        },

        // 产品
        queryProduct() {
            this.$http({
                url: '/buz/productBase/read/all',
                type: 'POST',
                data: {}
            }).then(res => {
                this.productList = res.data;
            });
        },

        setRequestParam() {
            let obj = JSON.parse(JSON.stringify(this.search));
            if (obj.validDate && obj.validDate[0]) {
                obj.startDate = filters.filterTime(obj.validDate[0], 'YYYY-MM-DD');
                obj.endDate = filters.filterTime(obj.validDate[1], 'YYYY-MM-DD');
            }
            if(this.cycleActiveIndex!=4){
                delete obj.startDate;
                delete obj.endDate;
            }
            obj.searchType = this.cycleActiveIndex;
            delete obj.validDate;
            let { ...params } = obj;
            return params;
        },

        // 列表
        initList() {
            this.$root.$children[0].isShowLoading = true;
            this.$http({
                url: '/buz/dataCenter/queryStatisticsList',
                type: 'PUT',
                data: this.setRequestParam(),
                apiPermissionCode:'dataCenter_1_2_0'
            })
                .then(res => {
                    this.total = res.total;
                    this.tableData = res.data.map(item => {
                        return {
                            ...item,
                            percent: item.finishRate ? Number(item.finishRate * 100).toFixed(2) + '%' : 0 + '%'
                        };
                    });
                })
                .finally(() => {
                    this.$root.$children[0].isShowLoading = false;
                });
        },

        // 统计
        initStatistics() {
            this.$http({
                url: '/buz/dataCenter/queryStatistics',
                type: 'PUT',
                data: this.setRequestParam()
            }).then(res => {
                this.statisticsObj = res.data;
            });
        },

        initData(key, data) {
            if(key == 'themeIds' && data) return;
            if(data || key == 'themeIds'){
                if(key=='themeIds'){
                    this.search.productType = '';
                    this.search.productCode = '';
                }else if(key=='productType') {
                    this.search.themeIds = [];
                    this.search.productCode = '';
                }else if(key=='productCode') {
                    this.search.themeIds = [];
                    this.search.productType = '';
                }
            }
            let maxDays = filters.getDiffDay(this.search.validDate[1], this.search.validDate[0]);
            if (maxDays > 366 && this.cycleActiveIndex==4) {
                this.$Message.error('统计周期区间最长为366天');
                this.result = true;
                return
            }
            this.result = false;
            this.initList();
            this.initStatistics();
        },

        // 选中日期
        changeDatePicker(key) {
            let maxDays = filters.getDiffDay(this.search.validDate[1], this.search.validDate[0]);
            if (maxDays > 366 && this.cycleActiveIndex==4) {
                this.$Message.error('统计周期区间最长为366天');
                this.$refs[key].visible = true;
                this.result = true;
                return
            }
            this.result = false;
            this.initData();
        },

        // 根据字段排序
        tableSortChange(column) {
            if (column.order == 'asc') {
                delete this.search.desc;
                this.search.ascs = column.key;
            } else if (column.order == 'desc') {
                delete this.search.ascs;
                this.search.desc = column.key;
            } else if (column.order == 'normal') {
                delete this.search.ascs;
                this.search.desc = column.key;
            }
            this.initData();
        },

        // 统计周期切换
        clickCycle(value) {
            this.cycleActiveIndex = value;   
            if(value != 4){
                this.initData();
                this.setDatePeriod();
            }
            this.result = false;
        },

        // 分页
        pageChange(pageNo) {
            this.search.pageNo = pageNo;
            this.initList();
        }
    }
};
</script>

<style lang="scss" scoped>
.star {
    color: #e3461f;
    margin-right: 4px;
    margin-top: 2px;
}
.input-item-01 {
    position: relative;
    display: flex;
    align-items: center;
    height: 30px;
    .label {
        margin-right: 10px;
    }
    .tips {
        color: #ed4014;
        position: absolute;
        bottom: -20px;
        right: 70px;
        font-size: 14px;
    }
}
.cycle {
    display: flex;
    .tab {
        margin-right: 10px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #e3e5e8;
        border-radius: 2px;
        a {
            display: block;
            font-size: 13px;
            color: #515c6f;
        }
        &.active {
            background: #f4f7ff;
            border: 1px solid #236dff;
            a {
                color: #236dff;
            }
        }
    }
}
.config {
    position: absolute;
    right: 20px;
    top: 10px;
}
.statistics-container {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    .statistics-item {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        .num {
            font-size: 16px;
            color: #3c464f;
            font-weight: bold;
        }
        span {
            color: #515c6f;
            font-size: 13px;
        }
        .total-text {
            font-weight: bold;
            color: #515C6F;
            font-size: 13px;
        }
        .right-line {
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -10px;
            width: 1px;
            height: 20px;
            background: #dddddd;
        }
    }
}
.table-box {
    margin-top: 15px;
    .finish-rate {
        display: flex;
        align-items: center;
        .speed {
            margin-left: 35px;
            width: 50px;
            height: 12px;
            background: #f5f5f5;
            overflow: hidden;
            .speed-box {
                height: 100%;
                background: #55bc41;
            }
        }
        .num {
            display: block;
            margin-left: 10px;
            color: #515c6f;
            &.text-center {
                margin: 0 auto;
            }
            &.up-to {
                color: #ff5f00;
            }
        }
    }
    /deep/.no-img {
        width: 270px;
        height: 146px;
        margin-top: 60px;
        margin-bottom: 10px;
    }
    /deep/.no-data-text {
        font-size: 14px;
        color: #A8ADB7;
        margin-bottom: 30px;
    }
}

/deep/.ivu-tag-text{
    margin-right: 0!important;
}
/deep/.ivu-icon-ios-close{
    display: none!important;
}
</style>
